export const newBoardObj = {
  boardTitle: ["new title "],
  boardTitles: ["Growth Template", "Personal & Work Goals", "Hiring Funnel"],
  listTitles: [],
  cards: {},
  itemsToSwitch: null,
  colToSwitch: null
};



// WEBPACK FOOTER //
// ./src/newBoardObj.js